import { Component, OnInit } from '@angular/core'
import { BreadcrumbService } from '../shared-components/breadcrumb.service'
import { Router, ActivatedRoute } from '@angular/router'
import { DataPageOfUser, User, Practice } from '../../../api/models'
import { UserService } from '../../../api/services/user.service'
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api'
import { PracticesService, UserPracticesService } from '../../../api/services'

@Component({
  templateUrl: './user-practices.component.html',
})
export class UserPracticesComponent implements OnInit {
  users: DataPageOfUser = {}
  selectedUser: User
  cols: any[]
  lastName: string
  firstName: string
  practiceId: string
  rows: number
  Showrecords: boolean
  confirmDropuserDialogVisible = false
  userPractices: any[]
  selectedCategories: string[]
  practices: string[]
  displayAddPractices: boolean
  checked = true
  sourcePractice: Practice[]

  targetPractice: Practice[]
  selecteduser: number = -1

  constructor(
    private messageService: MessageService,
    private breadcrumbService: BreadcrumbService,
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private confirmation: ConfirmationService,
    private practservice: PracticesService,
    private userPracticesService: UserPracticesService,
  ) {
    this.breadcrumbService.setItems([{ label: '' }])
  }

  ngOnInit() {
    this.practiceId = localStorage.getItem('PracticeId')
    //  { field: 'status', header: 'Active', sort: true }

    this.cols = [
      { field: 'loginId', header: 'Uesr Name', sort: true },
      { field: 'lname', header: 'Last Name', sort: true },
      { field: 'fname', header: 'First Name', sort: true },
    ]

    // { field: 'group', subfield: 'groupName', header: 'Group', sort: false },
  }

  onAddPractice(userid: number): void {
    this.selecteduser = userid

    this.userPracticesService
      .userPracticesGetAllSourcePracticesOfMappedUser({ userId: userid })
      .subscribe((data) => {
        this.sourcePractice = data
        // console.log(data);
      })
    this.userPracticesService
      .userPracticesGetAllPracticesOfMappedUser({ userId: userid })
      .subscribe((data) => {
        this.targetPractice = data
        // console.log(data);
      })
    this.displayAddPractices = true
  }

  setUserpractices(): void {
    //console.log(this.targetPractice);
    var practiceIds = ''
    this.targetPractice.forEach(function (value) {
      debugger
      practiceIds = practiceIds + ',' + value.practiceid
    })

    this.userPracticesService
      .userPracticesSetAllPracticesOfMappedUser({
        PracticeIds: practiceIds,
        userId: this.selecteduser,
      })
      .subscribe((result) => {
        if (result.status.toLowerCase().indexOf('error') > -1) {
          this.messageService.add({
            key: 'alertToast',
            severity: 'error',
            detail: result.message,
              summary: 'ERROR',
            life: 5000,
          })
          this.displayAddPractices = true
        } else if (result.status.toLowerCase().indexOf('ok') > -1) {
          this.displayAddPractices = false
          this.messageService.add({
            key: 'alertToast',
            severity: 'success',
            detail: result.message,
            summary: 'Confirmation',
            life: 5000,
          })
        }
      })
  }

  nextPage($event: LazyLoadEvent) {
    debugger
    console.log($event)
    let nextPage = $event.first / $event.rows + 1
    var order = 'Asc'
    if ($event.sortOrder == -1) {
      order = 'Desc'
    }
    if ($event.first == 0) {
      this.getUserList(1, $event.sortField, order)
    } else {
      this.getUserList(nextPage, $event.sortField, order)
    }
  }
  clearUserList(): void {
    this.lastName = ''
    this.firstName = ''
    this.Showrecords = true
    this.getUserList(1, '', '')
  }
  getUserList(pageNumber: number, sortcolumn: string, sortorder: string): void {
    if (sortcolumn == '' && sortorder == '') {
      sortcolumn = 'loginId'
      sortorder = 'Asc'
    }
    //var serachtext = ''
    //if (this.lastName != '') {
    //  serachtext = this.lastName
    //} else if (this.firstName != '') {
    //  serachtext = this.firstName
      //}

      let serachtext = '';


      console.log(this.lastName);
      console.log(this.lastName);

      if (this.lastName && this.lastName.trim() !== '') {
          serachtext += "#LN#" + this.lastName.trim();
      }

      if (this.firstName && this.firstName.trim() !== '') {
          if (serachtext !== '') {
              serachtext += " AND ";
          }
          serachtext += "#FN#" + this.firstName.trim();
      }

    this.userService
      .userSearch({
        practiceId: this.practiceId,
        pageSize: 10,
        pageNumber: pageNumber,
        searchText: serachtext,
        SortByColumn: sortcolumn,
        SortByDirection: sortorder,
      })
      .subscribe((users) => {
        this.users = users

        console.log(this.users)
        this.rows = this.users.pageSize
        debugger
        if (this.users.totalRecords > 0) {
          this.Showrecords = true
        } else {
          this.Showrecords = false
        }
      })
  }
}
